import styled, { css } from 'styled-components';

export const Wrapper = styled.section<{
  $bgImage: string;
  $fullHeight?: boolean;
  $scroll?: boolean;
  $withBackground?: boolean;
  $constrainToViewHeight?: boolean;
}>`
  background-image: ${p => (p.$bgImage ? `url(${p.$bgImage})` : '')};
  background-color: ${Styles.color.white};
  ${p =>
    p.$scroll &&
    css`
      overflow: auto;
    `}
  ${p =>
    p.$fullHeight &&
    css`
      height: 100%;
    `}

    ${p =>
      p.$constrainToViewHeight &&
      css`
        max-height: 100vh;
      `}
`;
